<template>
  <div>
    <div>Habitica</div>
    <div class="copy block">
      <button @click="getCustomName">Generate new name</button>
      <button class="copy-text" v-if="displayName" @click="copyName">
        Copy display name: {{ this.displayName }}
      </button>
      <div class="copy-text" v-if="copied">Copied!</div>
    </div>
    <a class="dropmail block" href="http://www.dropmail.me" target="_blank"
      >Go to Dropmail</a
    >
    <div class="copy block">
      <button @click="copyPassword">
        Copy this password: {{ this.password }}
      </button>
      <div class="copy-text" v-if="copied2">Copied!</div>
    </div>
  </div>
</template>

<script>
import { slug } from "./scripts/slug";

export default {
  name: "Automation",
  data() {
    return {
      displayName: "",
      password: "Ve5t8u2323",
      copied: false,
      copied2: false,
    };
  },
  methods: {
    getCustomName() {
      this.displayName = slug();
    },
    copyName() {
      navigator.clipboard.writeText(this.displayName);
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 2000);
    },
    copyPassword() {
      navigator.clipboard.writeText(this.password);
      this.copied2 = true;
      setTimeout(() => {
        this.copied2 = false;
      }, 2000);
    },
  },
};
</script>

<style scoped>
.block {
  margin: 10px 0px;
  padding: 4px;
}
.dropmail {
  display: block;
  box-sizing: border-box;
  width: 130px;
}
.copy {
  display: flex;
}
.copy-text {
  margin-left: 5px;
}
</style>